/**
 * Supabase Environment Configuration
 *
 * Defines both dev and prod Supabase environments for runtime switching.
 * Both anon keys are included in the bundle, which is acceptable because:
 * - Supabase anon keys are designed to be public
 * - RLS policies protect sensitive data
 * - Admin operations are verified server-side via Clerk tokens
 */

export type EnvironmentId = 'dev' | 'prod'

export interface SupabaseEnvironment {
  id: EnvironmentId
  label: string
  url: string
  anonKey: string
  region: string
  badgeVariant: 'secondary' | 'destructive'
}

export const SUPABASE_ENVIRONMENTS: Record<EnvironmentId, SupabaseEnvironment> = {
  dev: {
    id: 'dev',
    label: 'Development',
    url: import.meta.env.VITE_SUPABASE_DEV_URL || import.meta.env.VITE_SUPABASE_URL || '',
    anonKey: import.meta.env.VITE_SUPABASE_DEV_ANON_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY || '',
    region: 'Sydney',
    badgeVariant: 'secondary', // orange
  },
  prod: {
    id: 'prod',
    label: 'Production',
    url: import.meta.env.VITE_SUPABASE_PROD_URL || '',
    anonKey: import.meta.env.VITE_SUPABASE_PROD_ANON_KEY || '',
    region: 'Mumbai',
    badgeVariant: 'destructive', // red
  },
}

/**
 * Get list of available environments (those with valid credentials)
 */
export function getAvailableEnvironments(): EnvironmentId[] {
  const environments: EnvironmentId[] = []

  if (SUPABASE_ENVIRONMENTS.dev.url && SUPABASE_ENVIRONMENTS.dev.anonKey) {
    environments.push('dev')
  }

  if (SUPABASE_ENVIRONMENTS.prod.url && SUPABASE_ENVIRONMENTS.prod.anonKey) {
    environments.push('prod')
  }

  return environments
}
